import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import PageNotFound from '../features/errors/pages/PageNotFound';
import Report from '../features/reports/pages/Report';
import Login from '../features/auth/pages/Login';
import RequireAuth from '../components/auth/RequireAuth';
import ListSellers from '../features/users/pages/ListSellers';
import ViewSeller from '../features/users/pages/ViewSeller';
import ListBuyers from '../features/users/pages/ListBuyers';
import ListPendingUser from '../features/users/pages/ListPendingUser';
import ListVehicles from '../features/vehicles/pages/ListVehicles';
import ViewVehicle from '../features/vehicles/pages/ViewVehicle';
import ListAuctionVehicles from '../features/auctions/pages/ListAuctionVehicles';
import ViewBuyer from '../features/users/pages/ViewBuyer';
import ListAdmins from '../features/users/pages/ListAdmins';
import NextAuction from '../features/auctions/pages/NextAuction';
import LiveAuction from '../features/auctions/pages/LiveAuction';
import PastAuctions from '../features/auctions/pages/PastAuctions';
import AuctionResult from '../features/auctions/pages/AuctionResult';
import ForgotPassword from '../features/auth/pages/ForgotPassword';
import PasswordReset from '../features/auth/pages/PasswordRest';
import ChangePassword from '../features/profile/pages/ChangePassword';
import NextAuctionUsers from '../features/auctions/pages/NextAuctionUsers';

const routes = (
  <BrowserRouter>
    <Routes>
      <Route path='/login' element={<Login />}></Route>
      <Route path='/forgot-password' element={<ForgotPassword />}></Route>
      <Route path='/password-reset' element={<PasswordReset />}></Route>
      <Route path='/' element={<RequireAuth />}>
        <Route index element={<Navigate to='/vehicles?view=new' replace />} />
        <Route path='/change-password' element={<ChangePassword />}></Route>
        <Route path='users/admins' element={<ListAdmins />} />
        <Route path='users/sellers' element={<ListSellers />} />
        <Route path='users/sellers/:sellerId' element={<ViewSeller />} />
        <Route path='users/buyers' element={<ListBuyers />} />
        <Route path='users/buyers/:buyerId' element={<ViewBuyer />} />
        <Route path='users/pending' element={<ListPendingUser />} />
        <Route path='auctions' element={<NextAuction />} />
        <Route path='auctions/:auctionId' element={<ListAuctionVehicles />} />
        <Route path='auctions/next' element={<NextAuction />} />
        <Route path='auctions/next/users' element={<NextAuctionUsers />} />
        <Route path='auctions/past' element={<PastAuctions />} />
        <Route path='auctions/live' element={<LiveAuction />} />
        <Route path='auctions/result' element={<AuctionResult />} />
        <Route path='vehicles' element={<ListVehicles />} />
        <Route path='vehicles/:vehicleId' element={<ViewVehicle />} />
        <Route path='reports/:reportType' element={<Report />} />
      </Route>
      <Route path='*' element={<PageNotFound />} />
    </Routes>
  </BrowserRouter>
);

export default routes;
